import { movies } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";
import type { Movie } from "@/types/media";

export default function RelatedMovies({ movie }: { movie: Movie }) {
  const related = movies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      let score = 0;
      score += m.genres.filter((g) => movie.genres.includes(g)).length * 2;
      score += m.actors.filter((a) => movie.actors.some((x) => x.id === a.id)).length * 3;
      if (m.region === movie.region) score += 1;
      return { m, score };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 6)
    .map((x) => x.m);

  if (related.length === 0) return null;

  return (
    <section className="mt-12">
      <h2 className="font-heading font-bold text-xl text-foreground-950 flex items-center gap-2 mb-4">
        <span className="w-1 h-5 rounded-full bg-accent-500"></span>
        相关推荐
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {related.map((m) => (
          <MovieCard key={m.id} movie={m} />
        ))}
      </div>
    </section>
  );
}